// ForgotPassword.jsx
import React, { useState, useEffect } from 'react';
import './ForgotPassword.css';
import { useNavigate } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './firebase';
import { ClipLoader } from 'react-spinners';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  const [message, setMessage] = useState(''); // <-- message inside UI

  // cooldown timer for too-many-requests prevention
  useEffect(() => {
    if (cooldown <= 0) return;
    const timer = setInterval(() => setCooldown(prev => prev - 1), 1000);
    return () => clearInterval(timer);
  }, [cooldown]);

  const handleReset = async () => {
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setMessage('❌ Please enter your email.');
      return;
    }
    if (cooldown > 0) {
      setMessage(`⏳ Wait ${cooldown}s before trying again.`);
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      // Use Firebase default password reset page
      await sendPasswordResetEmail(auth, trimmedEmail, {
        url: 'https://www.apkaghr.com/signin', // redirect after reset
        handleCodeInApp: false,
      });

      setMessage(`📩 If an account exists, a password reset link has been sent to ${trimmedEmail}.`);
      setEmail('');
      setCooldown(60); // 60s cooldown
    } catch (err) {
      console.error('Password reset failed:', err);

      if (err.code === 'auth/too-many-requests') {
        setMessage('🚫 Too many requests. Please wait a few minutes.');
        setCooldown(60);
      } else if (err.code === 'auth/invalid-email') {
        setMessage('❌ Invalid email format.');
      } else {
        // Generic success message for security
        setMessage(`📩 If an account exists, a password reset link has been sent to ${trimmedEmail}.`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <h1>Forgot Password</h1>

        <input
          type="email"
          placeholder="Enter your registered email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button onClick={handleReset} disabled={loading || cooldown > 0}>
          {loading ? (
            <ClipLoader size={20} color="#fff" />
          ) : cooldown > 0 ? (
            `Wait ${cooldown}s`
          ) : (
            'Send Reset Link'
          )}
        </button>

        {/* ✅ Message displayed inside the card */}
        {message && <p className="reset-message">{message}</p>}

        <p onClick={() => navigate('/signin')} className="back-to-signin">
          Back to Sign In
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;


